var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.958008,
    y: 8,
    width: 3.99999,
    height: 4,
    fill: "#039855"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.958,
    y: 12,
    width: 4,
    height: 3.99999,
    transform: "rotate(180 12.958 12)",
    fill: "#027A48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95801 7.99999L8.958 4V7.99999L4.95801 12V7.99999Z",
    fill: "#A6F4C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95801 12L4.95802 16L4.95802 12L8.95801 8.00001L8.95801 12Z",
    fill: "#6CE9A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.958008 7.99999L8.95799 0V3.99999L4.958 7.99999H0.958008Z",
    fill: "#32D583"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.958 12L4.95802 20L4.95802 16L8.95801 12L12.958 12Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany02);
export default __webpack_public_path__ + "static/media/company-02.52021fb9a0196dd51b70d10d1347419f.svg";
export { ForwardRef as ReactComponent };